var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Finalized Syllabus")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " Please make the needed edits based on the feedback received on your Syllabus draft. When finished, please resubmit the sharing link (with editing enabled) to the SL Portal. "
        )
      ]),
      _vm.showCheckWrap
        ? _c(
            "Button",
            {
              staticClass: "btn-download mt-20",
              attrs: { skin: "grey" },
              on: { click: _vm.handleClickDownload }
            },
            [_vm._v("Your current syllabus")]
          )
        : _vm._e(),
      _c("p", { staticClass: "text bold big mt-30" }, [
        _vm._v(
          "Please paste the final syllabus sharing link here and click submit."
        )
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: { counter: false, placeholder: "", value: _vm.value.link },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "link")
              }
            }
          })
        ],
        1
      ),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }